import styled from 'styled-components'

import { Props } from './types'

export default styled.div<Props>`
  display: ${(props: Props): string => (props.displayBlock ? 'block' : 'inline-block')};
  img {
    width: 100%;
    ${({ width720 }: Props): string => (width720 ? 'max-width: 720px;' : '')}
    ${({ width320 }: Props): string => (width320 ? 'max-width: 320px;' : '')}
    height: ${(props: Props): string => (props.height280 ? '280px' : 'auto')};
    display: block;
    margin: auto;
    margin: ${(props: Props): string => (props.hasMargin ? '0 auto 30px auto' : 'auto')};
  }
`
